import React from 'react';
import Card from '../../../../../../components/LazyWidgets/Card';
import insightsEmptyState from './images/insights_empty_state.png';
import style from './index.module.css';

const WidgetEmptyState = () => (
  <Card className={style.card}>
    <div>
      <img src={insightsEmptyState} alt="No Widgets Exist" />
    </div>
    <div>
      <h1 className={style.title}>You have no Insights added to your dashboard.</h1>
    </div>
    <p className={style.body}>Assignment Performance Insights such as score distribution, completion status, and time spent data will be added to your dashboard after you assign assessments and/or adaptive quizzes in your course.</p>
  </Card>
);

export default WidgetEmptyState;
